import { themeGet } from '@upright/ui/common/generic/theme/custom-theme';
import { commonInfoBoxPadding } from '@upright/ui/common/upright/core/impact-lens-profile/common/components/info-boxes/styles';
import { LensBoxMode } from '@upright/ui/common/upright/core/impact-lens-profile/common/layout/types';
import { useCarouselContext, useCarouselLayout } from '@upright/ui/common/upright/core/impact-lens-profile/context';
import InterfaceDelete from '@upright/ui/icons/img/streamline-mini-line/interface-essential/add-remove-delete/interface-delete-1.svg';
import { ReactNode } from 'react';
import styled from 'styled-components';

interface Props {
  children: ReactNode;
  showClose?: boolean;
  onClick?: () => void;
}

export function InfoBoxTitleRow(props: Props) {
  const context = useCarouselContext();
  const layout = useCarouselLayout();
  const modalMode = layout.boxMode === LensBoxMode.MODAL;
  const showClose = props.showClose !== undefined ? props.showClose : modalMode;

  const handleClick = () => {
    const newState = context.lens.getClearedSelectionState?.(context.selectionState);
    if (newState) {
      context.setSelectionState(newState);
    }
  };
  const onClick = props.onClick ? props.onClick : handleClick;
  return (
    <Root>
      <Main>{props.children}</Main>
      {showClose && (
        <InterfaceDelete
          onClick={onClick}
          style={{ flexGrow: 0, flexShrink: 0, width: '1.0em', height: '1.0em', cursor: 'pointer' }}
        />
      )}
    </Root>
  );
}

const Main = styled.div`
  display: flex;
  align-items: center;
  flex-grow: 1;
`;

const Root = styled.div`
  display: flex;
  align-items: center;
  font-size: 13px;
  font-weight: 500;
  justify-content: space-between;
  ${commonInfoBoxPadding};
  background-color: ${themeGet('colors.bg.muted')};
  border-bottom: 1px solid ${themeGet('colors.border.default')};
`;
